import type { SVGProps } from 'react';

const SvgBranchOtherOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      d="M5 3v4a3 3 0 0 0 3 3h8a1 1 0 0 1 1 1v6.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L19 17.586V11a3 3 0 0 0-3-3H8a1 1 0 0 1-1-1V3zm0 14.586V11a5 5 0 0 0 2 .9v5.686l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414z"
    />
  </svg>
);

export default SvgBranchOtherOutline;
